import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import "../../assets/admin/css/styles.css";
import "../../assets/admin/css/modern-admin.css";
import routes from "../../routes/AdminRouteList";
import { Redirect, Route, Switch } from "react-router-dom";
import ThemeEditor from "../../components/admin/Themes/ThemeEditor";
import WhatsAppButton from "../../components/frontend/WhatsAppButton";

export default function Masterlayout() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const isThemeEditor =
    location.pathname === "/admin/theme-editor" ||
    location.pathname.startsWith("/admin/theme-editor");

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const lock = () => {
      document.body.style.overflow = window.innerWidth < 992 ? "hidden" : "";
    };
    lock();
    window.addEventListener("resize", lock);
    return () => {
      window.removeEventListener("resize", lock);
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  // If on Theme Customizer, render full-screen Studio mode without dashboard chrome
  if (isThemeEditor) {
    return (
      <div
        className="theme-editor-studio-fullscreen"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100vw",
          height: "100vh",
          zIndex: 5000,
          overflow: "hidden",
          backgroundColor: "#eef0f3",
        }}
      >
        <ThemeEditor />
      </div>
    );
  }

  return (
    <div className="admin-app-wrapper">
      {/* Sleek Sidebar */}
      {menuOpen && (
        <button
          type="button"
          className="admin-sidebar-backdrop"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      )}
      <Sidebar open={menuOpen} onClose={() => setMenuOpen(false)} />

      {/* Main Content Area */}
      <div className="admin-main-container">
        <Navbar onMenu={() => setMenuOpen(true)} />

        <main className="admin-page-body">
          <Switch>
            {routes.map(
              (route, index) =>
                route.component && (
                  <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    name={route.name}
                    render={(props) => {
                      return <route.component {...props} />;
                    }}
                  />
                )
            )}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
        </main>

        <Footer />
      </div>
      <WhatsAppButton />
    </div>
  );
}
